import { render, staticRenderFns } from "./IndexApproval.vue?vue&type=template&id=5f372d32&scoped=true"
import script from "./IndexApproval.vue?vue&type=script&lang=js"
export * from "./IndexApproval.vue?vue&type=script&lang=js"
import style0 from "./IndexApproval.vue?vue&type=style&index=0&id=5f372d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f372d32",
  null
  
)

export default component.exports